

















import { Vue, Component, PropSync, Prop } from 'vue-property-decorator';
import {Getter} from 'vuex-class';
import {Mall} from 'supporter';
import CompSelectBox from '@/components/common/CompSelectBox.vue';

@Component({
  components: {
    CompSelectBox
  }
})
export default class MallSelect extends Vue{
  @Getter('mall/malls')
  private malls: Mall[];

  @Prop({ default: 'CLAIM_CONTENT_TOP_ALL' })
  private readonly needAllText: string;

  @PropSync('mallNo')
  private mallNoSync!: undefined | number;

  mounted() {
    this.mallNoSync = this.mallSelectList[0].value;
  }

  public focus() {
    (this.$refs.mallSelectRef as CompSelectBox).focus();
  }

  private get mallSelectList(){
    return this.malls.map(mall => ({
      option: mall.mallName,
      value: mall.mallNo
    }));
  }

  inOnlyOneItem(): boolean{
    if(this.mallSelectList.length === 1){
      this.mallNoSync = this.mallSelectList[0].value
      return true
    }

    return false
  }

  private handleChange(_, prev) {
    this.$emit('changed-mall-no', prev);
  }
}
